import type { MaybeRefOrGetter } from 'vue'

// Esconde a barra de rolagem vertical da página (trava o scroll do <html>)
// enquanto `active` for verdadeiro. Restaura ao desativar ou desmontar.
export function useBodyScrollLock(active: MaybeRefOrGetter<boolean>): void {
  if (!import.meta.client)
    return

  const apply = (on: boolean): void => {
    document.documentElement.style.overflow = on ? 'hidden' : ''
  }

  watchEffect(() => apply(toValue(active)))
  onScopeDispose(() => apply(false))
}
